import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    chipsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12px',
      padding: '12px 0px',
    },
    chip: {
      border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT} !important`,
      height: '28px !important',
      '& .MuiChip-label': {
        color: STYLE.COLOR.TEXT1,
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: 500,
        padding: '0px 16px 0px 16px',
      },
      // color: STYLE.COLOR.ACCENT_SECONDARY,
      // "&.MuiChip-outlined": {
      //   borderColor: STYLE.COLOR.ACCENT_SECONDARY,
      // },
    },
    selectedChip: {
      border: `1px solid ${STYLE.COLOR.ACCENT_PRIMARY_LIGHTER} !important`,
      backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3} !important`,
      '& .MuiChip-label': {
        color: `${STYLE.COLOR.ACCENT_PRIMARY_LIGHTER} !important`,
      },
    },
    deleteIcon: {
      fontSize: '16px',
      color: STYLE.COLOR.TEXT2,
      cursor: 'pointer',
      marginRight: '8px',
    },
  }),
);
